import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, ListSubheader, type SxProps, type Theme } from '@mui/material';
import { delphiService, type GeminiModel } from '../services/delphiApi';

interface GeminiModelSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * Dropdown for the Gemini model list from GET /api/delphi/models/ (source of
 * truth: delphi/services/gemini_models.py). An empty selection means "use
 * the server default for this action" (tier1 for drafts, tier2 for
 * refine/SEO/social/translate) rather than a specific model.
 */
const GeminiModelSelect: React.FC<GeminiModelSelectProps> = ({
  value,
  onChange,
  label = 'Gemini Model',
  size = 'small',
  fullWidth = true,
  sx,
}) => {
  const [models, setModels] = useState<GeminiModel[]>([]);

  useEffect(() => {
    delphiService.listModels().then(setModels).catch((err) => console.error('Failed to load Gemini models:', err));
  }, []);

  const proModels = models.filter((m) => m.family === 'pro');
  const flashModels = models.filter((m) => m.family === 'flash');

  return (
    <FormControl size={size} fullWidth={fullWidth} sx={sx ?? (fullWidth ? undefined : { minWidth: 220 })}>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={value || ''}
        displayEmpty
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="">
          <em>Default</em>
        </MenuItem>
        {proModels.length > 0 && <ListSubheader>Pro</ListSubheader>}
        {proModels.map((m) => (
          <MenuItem key={m.id} value={m.id}>{m.label}</MenuItem>
        ))}
        {flashModels.length > 0 && <ListSubheader>Flash</ListSubheader>}
        {flashModels.map((m) => (
          <MenuItem key={m.id} value={m.id}>{m.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GeminiModelSelect;
